// extracted by mini-css-extract-plugin
export var content = "layout-module--content--K-wVB";
export var contentWithPaddingTop = "layout-module--contentWithPaddingTop--RTypX";
export var main = "layout-module--main--5VKR9";
export var mainWithPaddingTop = "layout-module--mainWithPaddingTop--yjisg";
export var wrapper = "layout-module--wrapper--vjEpw";